import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod

 const PostRemoveMobilePanelClientTranslation = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.RemoveMobilePanelClientTranslation,
   method: RequestType.POST,
   data,
 }); 
 const PutMobilePanelClientTranslation  = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.UpdateMobilePanelClientTranslation,
   method: RequestType.PUT,
   data, 
 }); 
 const CreateMobilePanelClientTranslation  = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.CreateMobilePanelClientTranslation,
   method: RequestType.POST,
   data, 
 }); 

 const BulkUploadMobilePanelClientTranslations = (data: any): Promise<any>  =>
 request({
   url: ApiURL.Command.BulkUploadMobilePanelClientTranslations,
   method: RequestType.POST,
   data, 
 }); 

 const MobilePanelClientTranslationsCommand = {
    PostRemoveMobilePanelClientTranslation,
    PutMobilePanelClientTranslation,
    CreateMobilePanelClientTranslation,
    BulkUploadMobilePanelClientTranslations
  }
  
  export default MobilePanelClientTranslationsCommand;